import React from 'react';

import { Box } from '@bcp-nextgen-dx-component-factory/design-system';
import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { ComponentInfo, DisplayGroupRender } from '@components';
import { LEFT_PANEL_WIDTH } from '@constants';
import { rem } from '@helpers';
import { useValuesByScreenSize } from '@hooks';
import { ROUTES } from '@navigation';

export const BodyPanel: React.FC<DisplayGroupProps> = (props: DisplayGroupProps) => {
	const valuesByScreenSize = useValuesByScreenSize(rem(56, 106, 222, 106), rem(56, 48, 222, 48));
	const padding = window.location.pathname !== ROUTES.intro ? valuesByScreenSize : 'unset';

	return (
		<ComponentInfo
			name="BodyPanel"
			type="displayGroup"
			as={Box}
			styles={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				flexGrow: 1,
				padding,
				width: `calc(100vw - ${rem(LEFT_PANEL_WIDTH)})`,
			}}
		>
			<DisplayGroupRender displayGroupsProps={props} />
		</ComponentInfo>
	);
};
